import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from "moment";
import { InstructorTableCellType } from "@/enums/InstructorTableCellType";
import ServiceIcon from "@/components/ServiceIcon.vue";
import { shortenString } from "@/plugins/helpers";
import { isDesktop } from "@/utils/isDesktop";
let Agenda = class Agenda extends Vue {
    selectedDate = '';
    events = [];
    listener = null;
    colors = {
        'wex': '#9c27b0',
        'snb': '#0D47A1',
        'ski': '#1E88E5',
        'storno': '#EF5350',
        'kidSchool': 'orange',
    };
    dayFrom = 8;
    dayTo = 22;
    nowY = '-10px';
    get title() {
        return (this.selectedDate !== '' ? moment(this.selectedDate) : moment()).format('DD.MM.YYYY');
    }
    get calendarHeight() {
        return isDesktop() ? 700 : null;
    }
    get cal() {
        return this.$refs.calendar;
    }
    mounted() {
        this.cal.checkChange();
        this.renderNow();
    }
    beforeDestroy() {
        if (this.listener !== null) {
            this.listener();
        }
    }
    prev() {
        this.cal.prev();
    }
    next() {
        this.cal.next();
    }
    renderNow() {
        if (this.selectedDate !== '' && moment(this.selectedDate).format('DD.MM.YYYY') !== moment().format('DD.MM.YYYY')) {
            this.nowY = '-10px';
            return;
        }
        this.nowY = this.cal.timeToY(this.cal.times.now) + 'px';
    }
    async fetchEvents({ start, end }) {
        const date = moment(start.date);
        await this.$store.dispatch('instructorTable/loadDates', [date]);
        await this.$nextTick();
        setTimeout(async () => {
            if (this.listener !== null) {
                this.listener();
            }
            this.listener = await this.$store.dispatch('instructorTable/listen', {
                date,
                callback: () => {
                    this.mapAgenda(date);
                },
            });
        }, 2000);
        this.mapAgenda(date);
        await this.$nextTick();
        this.renderNow();
    }
    mapAgenda(date) {
        const agendaEvent = this.$store.getters['instructorTable/get'](date);
        this.events = [];
        if (agendaEvent === undefined) {
            return;
        }
        this.dayFrom = agendaEvent.fromHour;
        this.dayTo = agendaEvent.toHour;
        for (const row of agendaEvent.getOrderedRows(false)) {
            for (const cell of row.cells) {
                if (![InstructorTableCellType.RESERVED, InstructorTableCellType.KID_SCHOOL].includes(cell.cellType)) {
                    continue;
                }
                let start = date.clone().add(cell.hour, 'hours');
                let end = start.clone().add(cell.length, 'hours');
                let note = shortenString(cell.note ?? '', isDesktop() ? 170 : 90);
                if (cell.kidSchoolId !== undefined) {
                    const school = agendaEvent.kidSchools.find((kidSchool) => kidSchool.id === cell.kidSchoolId);
                    if (school) {
                        start = date.clone()
                            .add(school.hourFrom, 'hours')
                            .add(school.minuteFrom, 'minutes');
                        end = start.clone().add(school.duration, 'minutes');
                        note = 'Obsazenost: ' + school.kids.length + '/' + school.capacity;
                    }
                }
                if (row.instructorId === undefined) {
                    note = 'Lekce nemá přiřazeného instruktora! ' + note;
                }
                this.events.push({
                    name: cell.calendarCaption,
                    phone: cell.phone ?? '',
                    note,
                    start: start.toDate(),
                    end: end.toDate(),
                    color: row.instructorId === undefined ? '#cbcbcb' : (this.colors[cell.service] ?? '#cbcbcb'),
                    service: cell.service,
                    timed: true,
                });
            }
        }
    }
    dateToTime(date) {
        return moment(date).format('HH:mm');
    }
};
Agenda = __decorate([
    Component({
        components: { ServiceIcon }
    })
], Agenda);
export default Agenda;
